
define('text!templates/modules/calendar/nutrition/food/food-content.html',[],function () { return '<div id="nutrition-food-search-content" class="panel-body panel-tag">\n    <div class="will-stick">\n        <ul class="menu-actions"></ul>\n        <div class="food-search"></div>\n    </div>\n    <div class="lists"></div>\n    <div class="load-button"></div>\n</div>\n';});

